import React from 'react';

import { Typography } from '@rbilabs/universal-components';

import OrderIssues from 'pages/order-confirmation/order-issues';
import { t } from 'state/intl/translations';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

import { OrderConfirmationHeader } from '../components/order-confirmation-header';
import { OrderDetailsCard } from '../components/order-details-card';
import { ServiceModeHeading } from '../components/service-mode-heading';
import { Container, Section } from '../styled';
import { IConfirmationUIProps } from '../type';

import DeliveryDisclaimer from './delivery-disclaimer';
import { DeliveryOrderCard } from './delivery-order-card';
import { useSavePendingDeliveryAddress } from './hooks/use-save-pending-delivery-address';

const DeliveryConfirmation: React.FC<React.PropsWithChildren<IConfirmationUIProps>> = ({
  serverOrder,
}) => {
  useSavePendingDeliveryAddress();
  const isShowingOrderingIssue = useFlag(LaunchDarklyFlag.SHOW_ORDERING_ISSUE);

  return (
    <Container>
      <Section>
        <OrderConfirmationHeader serverOrder={serverOrder} />
      </Section>

      <Section>
        <ServiceModeHeading serviceMode={serverOrder.cart.serviceMode} />
        <DeliveryOrderCard serverOrder={serverOrder} />
      </Section>

      <Section>
        <Typography variant="headerTwo">{t('order')}</Typography>
        <OrderDetailsCard order={serverOrder} />
      </Section>

      <Section>
        {isShowingOrderingIssue && (
          <OrderIssues>
            <DeliveryDisclaimer />
          </OrderIssues>
        )}
      </Section>
    </Container>
  );
};

export default DeliveryConfirmation;
